// extracted by mini-css-extract-plugin
export default {"Container":"Skeleton_Container__3o4EE","left":"Skeleton_left__RTKq6","right":"Skeleton_right__1RpMr"};